import React from "react"
import HelpIcon from "@mui/icons-material/Help"
import ExclamationIcon from "images/icon-exclamation.svg"
import styles from "./CommonHelp.module.scss"

export interface CommonHelpProps {
  text: string
  type?: string
  isError?: boolean
  click: () => void
}
/**
 * ヘルプリンク（モーダルを呼び出す青文字部分）
 * @param {string} text - ヘルプリンクの文言
 * @param {string} type - CSSスタイルを追加するための項目（クラス名に反映される）
 * @param {boolean} isError - エラーフラグ（未使用のため、削除予定）
 * @param {() => void} click - クリック時の処理
 */
const CommonHelp = ({ text, type = "default", isError = false, click }: CommonHelpProps) => {
  return (
    <span
      role="button"
      tabIndex={0}
      onClick={() => {
        click()
      }}
      onKeyPress={() => {}}
      className={styles[type]}
    >
      {isError ? (
        <div className={styles.exclamation}>
          <img width="16" height="16" src={ExclamationIcon} alt="exclamation" />
        </div>
      ) : (
        <HelpIcon className={styles.icon} fontSize="small" />
      )}

      {text}
    </span>
  )
}

export default CommonHelp
